import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-sort-down",
  "use": "tamr-icon-sort-down-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-sort-down\"><path d=\"M9.2,15.5l6,9a1,1,0,0,0,1.7,0l6-9A1,1,0,0,0,22,14H19V6H13v8H10A1,1,0,0,0,9.2,15.5Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol